// removed by extract-text-webpack-plugin
module.exports = {"wrapper-editor":"magazines_2-tHR","enterPageContainer":"magazines_3VErp","wrapper-editor__stage":"magazines_1Usd0","wrapper-editor__ruler":"magazines_3oiEC","wrapper-editor__content":"magazines_327Tc","wrapper-editor__content__active-overflow":"magazines_2IKUn","wrapper-editor__pages":"magazines_3OK7B","wrapper-editor__page":"magazines_3RgNx","wrapper-editor__page-info":"magazines_L901Z","wrapper-editor__page-active":"magazines_3RvbF","actions":"magazines_1ynsm","pages":"magazines_3ptHF","active":"magazines_2tbPA","page-navigation":"magazines_2uhH5","next":"magazines_1AhVj","prev":"magazines_sAG2Z"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Editor/components/Pages/styles.scss
// module id = 1233
// module chunks = 1